import { VOIntroductionPerson } from "../model/DataStructure.js";
import { Decoration } from "./Decoration.js";
import { PersonVideoControl } from "./PersonVideoControl.js";

export interface PersonDetailOptions {
    container: HTMLElement;
    visible?: boolean;
}

export class PersonDetail {

    private _element: HTMLElement;
    private _decoration: Decoration;
    private _video: HTMLVideoElement;
    private _videoControl: PersonVideoControl;

    constructor(options: PersonDetailOptions) {
        options = e5.object.merge({
            visible: true
        }, options);


        this._element = document.createElement("div");
        this._element.className = "person-detail";
        this._element.innerHTML = `
        
        <div class="person-detail__content">
            <div class="person-detail__body">
                <video class="person-detail__video"></video>
                <div class="person-detail__gradient"></div>
            </div>
            <div class="person-detail__footer">
                <div class="person-detail__text">
                    <div class="person-detail__name"></div>
                    <div class="person-detail__subtitle"></div>
                </div>
                <div class="person-detail__control"></div>
            </div>
        </div>        
        <div class="person-detail__decorations"></div>
        `;

        this._video = this._element.querySelector(".person-detail__video");
        this._video.loop = true;
        this._video.volume = 0;
        this._video.autoplay = true;

        this._decoration = new Decoration({
            container: this._element.querySelector(".person-detail__decorations"),
            visible: true,
            names: [
                "person-detail-2",
                "person-detail-6",
                "person-detail-10",
                "person-detail-14",
                "person-detail-16",
            ]
        });

        this._videoControl = new PersonVideoControl({
            container: this._element.querySelector(".person-detail__control"),
            video: this._video,
            visible: false
        });

        if (!options.visible) {
            this.visible = false;
        }

        if (options.container) {
            options.container.appendChild(this._element);
        }
    }

    public open(person: VOIntroductionPerson): void {
        this._element.querySelector(".person-detail__name").textContent = person.name;
        this._element.querySelector(".person-detail__subtitle").textContent = person.subtitle;
        this._element.style.setProperty("--accent-color", person.color);

        this._video.currentTime = 0;
        this._video.dispatchEvent(new Event("timeupdate"));

        if (person.video?.url) {
            this._video.src = person.video?.url;
            this._videoControl.visible = true;
            this._video.style.aspectRatio = person.video.width + "/" + person.video.height;
        } else {
            this._video.src = "";
            this._video.style.aspectRatio = "16/9";
            this._video.removeAttribute("src");
            this._videoControl.visible = false;
        }
    }

    public get visible(): boolean {
        return !this._element.classList.contains("person-detail--hidden");
    }

    public set visible(value: boolean) {
        if (this.visible === value) {
            return;
        }
        this._element.classList.toggle("person-detail--hidden", !value);
        this._decoration.visible = value;
        gsap.to(this._video, {
            duration: 0.5, volume: value ? 1 : 0, onComplete: () => {
                //Reduce energy consumption :)
                if (!this.visible) {
                    this._video.pause();
                }
            }
        });
    }
}